import { render, staticRenderFns } from "./PersonalLeaveEntitlementModal.vue?vue&type=template&id=2bd42119&scoped=true&"
import script from "./PersonalLeaveEntitlementModal.vue?vue&type=script&lang=js&"
export * from "./PersonalLeaveEntitlementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd42119",
  null
  
)

export default component.exports